export const initialState = {
  loading: false,
  activeStep: 0,
  activeTab: 0,
  cardProgram: null,
  selectedSavedCard: null,
  cardFormData: null,
  pointInfo: null,
  is3DModalOpen: false,
  iframeSrc: null,
  convertedPoints: null,
  paymentId: null,
  isDebitCard: false,
  cardHolderIsRequired: false,
};

export const pointConvertReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_ACTIVE_STEP":
      return { ...state, activeStep: action.payload };
    case "SET_ACTIVE_TAB":
      return { ...state, activeTab: action.payload };
    case "SET_CARD_PROGRAM":
      return { ...state, cardProgram: action.payload };
    case "SET_SELECTED_SAVED_CARD":
      return { ...state, selectedSavedCard: action.payload };
    case "SET_CARD_FORM_DATA":
      return { ...state, cardFormData: action.payload };
    case "SET_POINT_INFO":
      return { ...state, pointInfo: action.payload };
    case "SET_3D_MODAL_OPEN":
      return { ...state, is3DModalOpen: action.payload };
    case "SET_IFRAME_SRC":
      return { ...state, iframeSrc: action.payload };
    case "SET_CONVERTED_POINTS":
      return { ...state, convertedPoints: action.payload };
    case "SET_IS_DEBIT_CARD":
      return { ...state, isDebitCard: action.payload };
    default:
      return state;
    case "SET_PAYMENT_ID":
      return { ...state, paymentId: action.payload };
    case "SET_CARD_HOLDER_IS_REQUIRED":
      return { ...state, cardHolderIsRequired: action.payload };
  }
};

export default pointConvertReducer;
